export default {
    parts: [
        'container',
        'title',
        'subtitle',
        'toolbar',
        'toolbarLeft',
        'toolbarCenter',
        'toolbarRight',
        'itemCount',
        'showPreviousContainer',
        'showPreviousButton',
        'showMoreContainer',
        'showMoreButton',
        'grid',
        'errorMessage'
    ],
    baseStyle: {
        container: {
            paddingX: {base: '16px', lg: '24px'},
            paddingTop: {base: '16px', lg: '24px'},
            paddingBottom: '64px'
        },
        // Realm 1 (SFRA) landing-page typography, Garage values. The family is
        // the brand-aware `fonts.heading` token — GarageNeue on Garage, AzoSans
        // on Dynamite — so only the deltas (`text-transform: none`, regular
        // weight) live in the Dynamite brand override:
        // theme/brands/dynamite/components/project/ugc-landing-page.js
        title: {
            color: 'black',
            fontFamily: 'heading',
            fontSize: {base: '14px', lg: '16px'},
            fontWeight: 'bold',
            lineHeight: 1.2,
            letterSpacing: 'normal',
            margin: {base: '24px 0 16px', lg: '24px 0 12px'},
            padding: 0,
            textTransform: 'uppercase'
        },
        subtitle: {
            color: 'black',
            fontSize: '14px',
            lineHeight: 1.2,
            margin: {base: '0 0 24px', lg: '0 0 40px'}
        },
        toolbar: {
            display: {base: 'flex', lg: 'grid'},
            gridTemplateColumns: {lg: '1fr auto 1fr'},
            alignItems: 'center',
            justifyContent: {base: 'flex-start', lg: 'normal'},
            columnGap: {base: '12px', lg: 0},
            marginBottom: '16px'
        },
        // Mobile order (Figma): sort on the left, then the item count (Dynamite
        // only), with the grid-view buttons on the right. Desktop keeps the
        // count | grid buttons | sort layout.
        toolbarLeft: {justifySelf: 'start', order: {base: 2, lg: 0}},
        toolbarCenter: {
            justifySelf: 'center',
            order: {base: 3, lg: 0},
            marginLeft: {base: 'auto', lg: 0}
        },
        toolbarRight: {
            justifySelf: 'end',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            order: {base: 1, lg: 0}
        },
        itemCount: {fontSize: {base: '12px', lg: '13px'}, color: 'gray.600'},
        // Sort trigger reuses the PLP "Filters & Sort" `filter` button variant
        // for its border/layout, but pins the font weight to normal (Dynamite's
        // weight) on both brands. The options themselves live in the shared
        // SortSheet bottom sheet.
        showPreviousContainer: {marginBottom: {base: 6, lg: 8}},
        showPreviousButton: {width: {base: '100%'}, maxWidth: {base: '100%', lg: '342px'}},
        showMoreContainer: {marginTop: {base: 12, lg: 16}},
        showMoreButton: {width: {base: '100%'}, maxWidth: {base: '100%', lg: '342px'}},
        grid: {
            columnGap: '8px',
            rowGap: {base: '8px', lg: '32.06px'}
        },
        errorMessage: {textAlign: 'center', color: 'red.500', padding: '24px 0'}
    }
}
